import { Component, OnInit, Input } from '@angular/core';
import { VariableCrudManagerService, BaseVariableService, VariablesTemplateComponent } from '@wms/variables';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '@wms/app/components';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  standalone: true,
  selector: 'wms-imported-api-var-creation',
  templateUrl: './imported-api-var-creation.component.html',
  styleUrls: [],
  imports: [CommonModule, TooltipModule, VariablesTemplateComponent]
})
export class ImportedApiVarCreationComponent extends BaseComponent implements OnInit {
  @Input() selectedVarService: any;
  @Input() selectedServiceType: any;

  constructor(public varManagerService: VariableCrudManagerService, public baseVariableService: BaseVariableService) {
    super();
   }

  ngOnInit(): void {
    setTimeout(() => {
      this.varManagerService.showPrimaryProps = false;
    });
  }

  handleModelChange(changeObj: any) {
    this.varManagerService.initVariableObj.values[changeObj.propertyName] = changeObj.$event;
    this.selectedVarService.__onPropertyChange(changeObj.propertyName, changeObj.$event);
  }

}
